import {
  FETCH_PRODUCTGROUPS,
  FETCH_PRODUCTGROUPS_BY_SUPPLIER,
  FETCH_PRODUCTGROUPS_FARMER,
  FETCH_PRODUCTS_BY_GROUP,
  FETCH__SUPPLIERS,
} from "./actionTypes";

const initialState = {
  products: [],
  product_groups: [],
  product_groups_farmer: [],
  product_groups_by_supplier: [],
  suppliers: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case FETCH_PRODUCTS_BY_GROUP:
      return {
        ...state,
        products: action.payload,
      };
    case FETCH_PRODUCTGROUPS:
      return {
        ...state,
        product_groups: action.payload,
      };
    case FETCH_PRODUCTGROUPS_FARMER:
      return {
        ...state,
        product_groups_farmer: action.payload,
      };
    case FETCH_PRODUCTGROUPS_BY_SUPPLIER:
      return {
        ...state,
        product_groups_by_supplier: action.payload,
      };
    case FETCH__SUPPLIERS:
      return {
        ...state,
        suppliers: action.payload,
      };
    default:
      return state;
  }
}
